import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import DevicesAndAccessoriesBlockData from "../../../Models/Content/DevicesAndAccessoriesBlockData";
import DevicesAndAccessories from "./DevicesAndAccessories";

export default class DevicesAndAccessoriesBlock extends EpiComponent<DevicesAndAccessoriesBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["devices-and-accessories-block"];
    // if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    // if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <DevicesAndAccessories iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
